import { createSlice } from "@reduxjs/toolkit";
import { getGuardiansId, titleCase } from "helper";

const initialState = {
  showDataPreview: false,
  showRecursiveForm: true,
  isEditRecursiveForm: false,
  showAddMore: true,
  editIndex: "",
  arrayName: "",
  minLength: "",
  maxLength: "",
  //rework
  associateRequired: false,
  canCreateWorkflow: true,
  currentFormType: "applicant",
  guardianKey: "",
  guardianLabel: "",
  maxGuardianLimit: 5,
  minorCount: 0,
  //Majors that are not guardians
  nonGuardianMajors:0,
  isKeyDuplicate: false,
  isSignerRecursion: false,
  //end of rework
  formFields: [],
  formButtons: [],
  recursiveActions: [],
  showData: [],
  saveData: [],
  recursiveFormData: {},
  deleteRecursiveDocument: [],
  signerParams: {},
};

export const guardianReducer = createSlice({
  name: "guardianReducer",
  initialState,
  reducers: {
    //* use this to run any side-effects on saving and editing
    setAssociateRequired: (state, action) => {
      let associateRequired = false;
      for (const applicant of state.saveData) {
        if (applicant?.majority?.toLowerCase() === "minor")
          if (getGuardiansId(state.saveData, applicant.uid).length === 0) {
            associateRequired = true;
            break;
          }
      }
      state.minorCount = state.saveData.reduce(
        (accumulator, applicant) =>
          applicant.majority.toLowerCase() === "minor"
            ? (accumulator += 1)
            : accumulator,
        0
      );
      state.nonGuardianMajors = state.saveData.reduce(
        (accumulator, applicant) =>
          applicant.majority.toLowerCase() === "major" && !applicant.hasOwnProperty("guardian_of")
            ? (accumulator += 1)
            : accumulator,
        0
      );
      state.associateRequired = associateRequired;
    },
    setCurrentFormType: (state, action) => {
      state.currentFormType = action.payload;
    },
    setGuardianLabel: (state, action) => {
      state.guardianLabel = action.payload;
    },
    setIsKeyDuplicateGuardian: (state, action) => {
      state.isKeyDuplicate = action.payload;
    },
    setIsSignerRecursion: (state, action) => {
      state.isSignerRecursion = action.payload;
    },
    setFormFields: (state, action) => {
      state.formFields = action.payload;
    },
    clearFormFields: (state) => {
      state.formFields = [];
    },
    setFormButtons: (state, action) => {
      state.formButtons = action.payload;
    },
    clearFormButtons: (state) => {
      state.formButtons = [];
    },
    setRecursiveActions: (state, action) => {
      state.recursiveActions = action.payload;
    },
    clearRecursiveActions: (state) => {
      state.recursiveActions = [];
    },
    setShowDataPreview: (state, action) => {
      state.showDataPreview = action.payload;
    },
    setShowRecursiveForm: (state, action) => {
      state.showRecursiveForm = action.payload;
    },

    setShowData: (state, action) => {
      state.showData = [...state.showData, action.payload];
    },
    setAddShowData: (state, action) => {
      state.showData = [
        ...state.showData,
        { [action.payload.key]: action.payload.value },
      ];
    },
    setDeleteShowData: (state, action) => {
      state.showData = [
        ...state.showData.filter((item, i) => i != action.payload),
      ];
    },
    clearShowData: (state) => {
      state.showData = [];
    },
    setEditShowData: (state, action) => {
      if (action.payload.data.hasOwnProperty("uid")) {
        delete action.payload.data["uid"];
      }
      state.showData[action.payload.editIndex] = { ...action.payload.data };
    },
    setAddSaveData: (state, action) => {
      state.saveData = [...state.saveData, action.payload];
    },
    setEditSaveData: (state, action) => {
      state.saveData[action.payload.editIndex] = { ...action.payload.data };
    },
    setSaveData: (state, action) => {
      state.saveData = action.payload;
    },
    setDeleteSaveData: (state, action) => {
      state.saveData = [
        ...state.saveData.filter((item, i) => i != action.payload),
      ];
    },
    clearSaveData: (state, action) => {
      state.saveData = [];
    },

    setRecursiveFormData: (state, action) => {
      state.recursiveFormData = {
        ...state.recursiveFormData,
        [action.payload.key]: action.payload.value,
      };
    },
    clearRecursiveFormDataKey: (state, action) => {
      state.recursiveFormData = {
        ...state.recursiveFormData,
      };
      delete state.recursiveFormData[action.payload.key];
    },
    clearRecursiveFormData: (state) => {
      state.recursiveFormData = {};
    },

    setIsEditRecursiveForm: (state, action) => {
      state.isEditRecursiveForm = action.payload;
    },
    setEditIndex: (state, action) => {
      state.editIndex = action.payload;
    },

    setShowAddMore: (state, action) => {
      state.showAddMore = action.payload;
    },

    setArrayName: (state, action) => {
      state.arrayName = action.payload;
    },
    setGuardianKey: (state, action) => {
      state.guardianKey = action.payload;
    },
    setMinLength: (state, action) => {
      state.minLength = action.payload;
    },
    setMaxLength: (state, action) => {
      state.maxLength = action.payload;
    },
    setIsMinor: (state, action) => {
      state.isMinor = action.payload;
    },
    setAssociatedWf: (state, action) => {
      state.associatedWf = action.payload;
    },
    setIsAssociatedWfDisabled: (state, action) => {
      state.isAssociatedWfDisabled = action.payload;
    },
    setIsMinorDisabled: (state, action) => {
      state.isMinorDisabled = action.payload;
    },
    setAssociatedWfAge: (state, action) => {
      state.associatedWfAge = action.payload;
    },
    setIsEditMinor: (state, action) => {
      state.isEditMinor = action.payload;
    },
    setIsAssociated: (state, action) => {
      state.isAssociated = action.payload;
    },
    setIsAssociatedDisabled: (state, action) => {
      state.isAssociatedDisabled = action.payload;
    },
    setdeleteRecursiveDocument: (state, action) => {
      state.deleteRecursiveDocument.push(action.payload.value);
    },
    cleardeleteRecursiveDocument: (state, action) => {
      state.deleteRecursiveDocument = [];
    },
    setSignerParams: (state, action) => {
      if (action.payload.key) {
        state.signerParams = {
          ...state.signerParams,
          [action.payload.key]: action.payload.value,
        };
      }
    },
    clearSignerParams: (state, action) => {
      state.signerParams = {};
    },
    setMaxGuardianLimit: (state, action) => {
      state.maxGuardianLimit = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setFormFields,
  clearFormFields,
  setShowDataPreview,
  setShowData,
  setAddShowData,
  setSaveData,
  setAddSaveData,
  clearSaveData,
  clearShowData,
  setRecursiveFormData,
  clearRecursiveFormData,
  setDeleteSaveData,
  setDeleteShowData,
  setFormButtons,
  clearFormButtons,
  setShowRecursiveForm,
  clearRecursiveFormDataKey,
  setIsEditRecursiveForm,
  setEditIndex,
  setEditSaveData,
  setEditShowData,
  setEditSaveDataWithIndex,
  setEditShowDataWithIndex,
  setRecursiveActions,
  clearRecursiveActions,
  setShowAddMore,
  setArrayName,
  setMinLength,
  setMaxLength,
  setAssociatedWf,
  setIsMinor,
  setIsMinorDisabled,
  setIsAssociatedWfDisabled,
  setAssociatedWfAge,
  setIsEditMinor,
  setIsAssociated,
  setIsAssociatedDisabled,
  setAssociateRequired,
  setCurrentFormType,
  setIsKeyDuplicateGuardian,
  setIsSignerRecursion,
  setdeleteRecursiveDocument,
  cleardeleteRecursiveDocument,
  setSignerParams,
  clearSignerParams,
  setGuardianKey,
  setGuardianLabel,
  setMaxGuardianLimit,
} = guardianReducer.actions;

export default guardianReducer.reducer;
